import { Icon } from '@iconify/react/dist/iconify.js';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import { ErrorMessage, Form, Formik } from 'formik';
import SearchableDropdown from '../../../../../components/SearchableDropdown';
import ToggleSwitch from '../../../../../components/ToggleSwitch';
import React, { useEffect, useRef, useState } from 'react';
import { getCoords } from '../../../../../utils/helpers/geolocation';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { addCommunitySchema, normaliseEmailDomain } from '../../../../../validationSchema/SocietyController/SocietyManagement/SocietyManagementSchema';
import CreatedAdminModal from '../CreatedAdminModal';
import { useDispatch } from 'react-redux';
import { createCommunity, editCommunity, getCommunityDetails } from '../../../../../redux/actions/SocietyController/CtrlCommunityManagementAction/CtrlCommunityManagement';
import { getBrandsList } from '../../../../../redux/actions/SocietyController/CtrlBrandAction/CtrlBrand';
import { SOCIETY_CONTROLLER, SOCIETY_MANAGEMENT } from '../../../../../Routing/routes';
import { CircularProgress, InputAdornment } from '@mui/material';
import { useSelector } from 'react-redux';
import Loader from '../../../../../components/Looder';

const InputCustomStyles = ({ societyId = null }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const { createLoading, detailsLoading, communityDetails } = useSelector(state => state.CtrlCommunityManagementReducers)
    const { brandData } = useSelector(state => state.CtrlBrandReducers || {})
    const { id } = useParams()
    const formRef = useRef();
    // "Use my current location" spinner for the geofence center picker.
    const [locating, setLocating] = useState(false);
    // { admin, societyName } after a create — holds the one-time admin credentials.
    const [created, setCreated] = useState(null);

    // Preview of the admin login: <firstWordOfName>.<id>@<domain>. The id is
    // only assigned on create, so it stays a placeholder here.
    const adminEmailPreview = (name, domain) => {
        const first = String(name || '').trim().split(/\s+/)[0].toLowerCase().replace(/[^a-z0-9]/g, '');
        return `${first || 'society'}.<id>@${normaliseEmailDomain(domain) || 'your-domain.com'}`;
    };

    // Convert the geofence form fields into the shape the API expects:
    // empty strings → null, and numeric strings → numbers.
    const buildGeofencePayload = (values) => {
        const num = (v) => (v === '' || v === null || v === undefined ? null : Number(v));
        return {
            geofence_enabled: values.geofence_enabled ? 1 : 0,
            geofence_enforce: values.geofence_enforce ? 1 : 0,
            geofence_latitude: num(values.geofence_latitude),
            geofence_longitude: num(values.geofence_longitude),
            geofence_radius_meters: num(values.geofence_radius_meters) ?? 200,
        };
    };
    // TODO: If isEditMode, fetch society data using societyId
    useEffect(() => {
        if (id) {
            // Fetch society data and populate form
            console.log('Edit mode - fetching data for society:', societyId);
            // Example: fetchSocietyData(societyId).then(data => setFormData(data))
            dispatch(getCommunityDetails({ id }))
        }
        // Brand list powers the Brand dropdown — fetch enough to cover most setups.
        dispatch(getBrandsList({ page: 1, limit: 100 }))
    // eslint-disable-next-line react-hooks/exhaustive-deps
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    const brandOptions = (brandData?.data || []).map((b) => ({
        value: b.brand_id,
        label: b.name,
    }));
    // Compact field sizing — keeps the form in line with the rest of the
    // controller screens (text-xs labels, ~34px inputs).
    const textFieldStyles = {
        '& .MuiInputLabel-root': {
            fontSize: '13px',
            transform: 'translate(12px, 8px) scale(1)',
        },
        '& .MuiInputLabel-root.MuiInputLabel-shrink': {
            transform: 'translate(14px, -7px) scale(0.8)',
        },
        '& .MuiInputBase-input': {
            fontSize: '13px',
            padding: '7px 12px',
        },
    };
    const labelCls = 'tw-block tw-text-xs tw-font-semibold tw-text-gray-600 tw-mb-1';
    return (
        <div className="col-lg-12">
            <CreatedAdminModal
                admin={created?.admin}
                societyName={created?.societyName}
                onClose={() => {
                    setCreated(null);
                    navigate(SOCIETY_CONTROLLER + SOCIETY_MANAGEMENT);
                }}
            />
            {console.log(communityDetails, '---')}
            <Formik
                initialValues={
                    id ?
                        {
                            name: communityDetails?.name,
                            type: communityDetails?.type,
                            registration_number: communityDetails?.registration_number,
                            registration_authority: communityDetails?.registration_authority,
                            brand_id: communityDetails?.brand_id ?? null,
                            // Geofence (employee attendance) — returned by GET /api/societies/:id
                            geofence_enabled: communityDetails?.geofence_enabled ? 1 : 0,
                            geofence_enforce: communityDetails?.geofence_enforce ? 1 : 0,
                            geofence_latitude: communityDetails?.geofence_latitude ?? '',
                            geofence_longitude: communityDetails?.geofence_longitude ?? '',
                            geofence_radius_meters: communityDetails?.geofence_radius_meters ?? 200,
                        } :
                        {
                            "name": "",
                            "type": "",
                            "registration_number": "",
                            "registration_authority": "",
                            "brand_id": null,
                            admin_email_domain: '',
                            geofence_enabled: 0,
                            geofence_enforce: 0,
                            geofence_latitude: '',
                            geofence_longitude: '',
                            geofence_radius_meters: 200,
                        }}
                enableReinitialize={true}
                validationSchema={addCommunitySchema({ isEdit: Boolean(id) })}
                onSubmit={(values, { resetForm, setSubmitting, setFieldError }) => {
                    const payload = { ...values, ...buildGeofencePayload(values) };
                    if (id) dispatch(editCommunity({
                        ...payload,
                        id: id,
                        onSuccess: () => {
                            navigate(SOCIETY_CONTROLLER + SOCIETY_MANAGEMENT);
                            resetForm();
                        }
                    }));
                    else dispatch(createCommunity({
                        ...payload,
                        admin_email_domain: normaliseEmailDomain(values.admin_email_domain),
                        onSuccess: (data) => {
                            resetForm();
                            // Stay on the page until the one-time credentials are acknowledged.
                            if (data?.admin?.email) {
                                setCreated({ admin: data.admin, societyName: data?.society?.name || values.name });
                            } else {
                                navigate(SOCIETY_CONTROLLER + SOCIETY_MANAGEMENT);
                            }
                        },
                        onError: (message) => {
                            if (String(message).includes('admin_email_domain')) {
                                setFieldError('admin_email_domain', message.replace(/^.*?admin_email_domain\s*/, 'Admin email domain '));
                            }
                        }
                    }));

                    setSubmitting(false);
                }}
                innerRef={(f) => (formRef.current = f)}

            >
                {(formik) => {
                    return (
                        <Form>
                            <div className="card">
                                <div className="card-header tw-flex tw-justify-between tw-items-center tw-gap-3 tw-flex-wrap">
                                    <div className='tw-flex tw-items-center tw-gap-2'>
                                        <button
                                            type='button'
                                            onClick={() => navigate(-1)}
                                            className='tw-h-8 tw-w-8 tw-inline-flex tw-items-center tw-justify-center tw-rounded-md tw-text-gray-500 hover:tw-bg-gray-100 hover:tw-text-rose-600 tw-transition-colors tw-border-0'
                                        >
                                            <Icon icon="solar:alt-arrow-left-outline" className="tw-text-base" />
                                        </button>
                                        <h5 className="tw-text-sm tw-font-bold tw-text-gray-800 tw-mb-0">
                                            {id ? `Edit Community Details (ID: ${id})` : 'Provide Community Details'}
                                        </h5>
                                    </div>
                                    <div className='tw-flex tw-gap-2'>
                                        <button
                                            type="button"
                                            disabled={detailsLoading || createLoading}
                                            className="tw-h-8 tw-inline-flex tw-items-center tw-gap-1 tw-px-3 tw-rounded-md tw-text-xs tw-font-medium tw-text-gray-600 tw-bg-white tw-border tw-border-gray-200 hover:tw-bg-gray-50 disabled:tw-opacity-50"
                                            onClick={() => { formik.resetForm() }}
                                        >
                                            {(detailsLoading || createLoading)
                                                ? <span className='tw-animate-spin tw-rounded-full tw-h-3 tw-w-3 tw-border-2 tw-border-gray-300 tw-border-t-gray-600' />
                                                : <Icon icon="mdi:refresh" className="tw-text-sm" />}
                                            Reset
                                        </button>
                                        <button
                                            type="submit"
                                            disabled={detailsLoading || createLoading}
                                            className="tw-h-8 tw-inline-flex tw-items-center tw-gap-1 tw-px-3 tw-rounded-md tw-text-xs tw-font-medium tw-text-white tw-bg-rose-600 hover:tw-bg-rose-700 disabled:tw-opacity-50 tw-transition-colors"
                                        >
                                            {(detailsLoading || createLoading)
                                                ? <span className='tw-animate-spin tw-rounded-full tw-h-3 tw-w-3 tw-border-2 tw-border-white tw-border-t-transparent' />
                                                : <Icon icon="mdi:check" className="tw-text-sm" />}
                                            {id ? 'Update' : 'Save'}
                                        </button>
                                    </div>
                                </div>
                                {(detailsLoading || createLoading) ? <Loader /> : <div className="card-body">
                                    <div className="row gy-3  ">
                                        <div className="col-md-4">
                                            <label className={labelCls}>Community Name  <span className="text-danger">*</span></label>
                                            <div>
                                                <TextField
                                                    name="name"
                                                    value={formik.values.name}
                                                    label="Enter details"
                                                    variant="outlined"
                                                    size="small"
                                                    className='tw-w-full'

                                                    sx={textFieldStyles}
                                                    onInput={(e) => { formik.setFieldValue('name', e.target.value) }}
                                                />
                                                <div
                                                    className={`text-danger text-sm italic h-4 text-wrap break-words mb-4`}
                                                >
                                                    <ErrorMessage name={`name`} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <label className={labelCls}>Registration Number  <span className="text-danger">*</span></label>
                                            <div>
                                                <TextField
                                                    name="name"
                                                    value={formik.values.registration_number}
                                                    label="Enter details"
                                                    variant="outlined"
                                                    size="small"
                                                    className='tw-w-full'

                                                    sx={textFieldStyles}
                                                    onInput={(e) => { formik.setFieldValue('registration_number', e.target.value) }}
                                                />
                                                <div
                                                    className={`text-danger text-sm italic h-4 text-wrap break-words mb-4`}
                                                >
                                                    <ErrorMessage name={`registration_number`} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <label className={labelCls}>Registration Authority  <span className="text-danger">*</span></label>
                                            <div>
                                                <TextField
                                                    name="name"
                                                    value={formik.values.registration_authority}
                                                    label="Enter details"
                                                    variant="outlined"
                                                    size="small"
                                                    className='tw-w-full'

                                                    sx={textFieldStyles}
                                                    onInput={(e) => { formik.setFieldValue('registration_authority', e.target.value) }}
                                                />
                                                <div
                                                    className={`text-danger text-sm italic h-4 text-wrap break-words mb-4`}
                                                >
                                                    <ErrorMessage name={`registration_authority`} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <label className={labelCls}>Property Type </label>
                                            <div>
                                                <SearchableDropdown
                                                    value={formik.values?.type || 'all'}
                                                    onChange={(v) => formik.setFieldValue('type', v === 'all' ? '' : v)}
                                                    options={[
                                                        { value: 'all', label: 'Select Property Type' },
                                                        { value: 'RESIDENTIAL', label: 'Residential' },
                                                        { value: 'COMMERCIAL', label: 'Commercial' },
                                                    ]}
                                                    placeholder="Select Property Type"
                                                    clearable={false}
                                                    small
                                                />
                                                <div
                                                    className={`text-danger text-sm italic h-4 text-wrap break-words mb-4`}
                                                >
                                                    <ErrorMessage name={`type`} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <label className={labelCls}>Brand</label>
                                            <div>
                                                <SearchableDropdown
                                                    value={formik.values?.brand_id ?? ''}
                                                    onChange={(v) => formik.setFieldValue('brand_id', v || null)}
                                                    options={brandOptions}
                                                    placeholder="Select Brand"
                                                    clearable
                                                    small
                                                />
                                                <div
                                                    className={`text-danger text-sm italic h-4 text-wrap break-words mb-4`}
                                                >
                                                    <ErrorMessage name={`brand_id`} />
                                                </div>
                                            </div>
                                        </div>

                                        {/* Admin email domain — create only; the API ignores it on edit */}
                                        {!id && (
                                            <div className="col-md-4">
                                                <label className={labelCls}>Admin Email Domain <span className="text-danger">*</span></label>
                                                <div>
                                                    <TextField
                                                        name="admin_email_domain"
                                                        value={formik.values.admin_email_domain ?? ''}
                                                        placeholder="greenvalley.com"
                                                        variant="outlined"
                                                        size="small"
                                                        className='tw-w-full'
                                                        sx={textFieldStyles}
                                                        error={Boolean(formik.touched.admin_email_domain && formik.errors.admin_email_domain)}
                                                        InputProps={{
                                                            startAdornment: <InputAdornment position="start"><span className="tw-text-xs tw-text-gray-500">@</span></InputAdornment>,
                                                        }}
                                                        onInput={(e) => formik.setFieldValue('admin_email_domain', e.target.value)}
                                                        // Show exactly what will be saved: trimmed, no "@", lower-case
                                                        onBlur={(e) => {
                                                            formik.setFieldValue('admin_email_domain', normaliseEmailDomain(e.target.value));
                                                            formik.setFieldTouched('admin_email_domain', true, false);
                                                        }}
                                                    />
                                                    <p className="tw-text-[11px] tw-text-gray-400 tw-mb-0 tw-mt-1 tw-truncate">
                                                        Admin login will be: <span className="tw-font-mono tw-text-gray-600">{adminEmailPreview(formik.values.name, formik.values.admin_email_domain)}</span>
                                                    </p>
                                                    <div className={`text-danger text-sm italic h-4 text-wrap break-words mb-4`}>
                                                        <ErrorMessage name={`admin_email_domain`} />
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        {/* ===================== Employee Geofence ===================== */}
                                        <div className="col-12">
                                            <div className="tw-rounded-lg tw-border tw-border-gray-200 tw-bg-gray-50/60 tw-p-4">
                                                <div className="tw-flex tw-items-start tw-justify-between tw-gap-3 tw-flex-wrap">
                                                    <div className="tw-flex tw-items-center tw-gap-2">
                                                        <Icon icon="solar:map-point-wave-bold-duotone" className="tw-text-rose-500 tw-text-lg" />
                                                        <div>
                                                            <h6 className="tw-text-sm tw-font-bold tw-text-gray-800 tw-mb-0">Employee Geofence Attendance</h6>
                                                            <p className="tw-text-[11px] tw-text-gray-500 tw-mb-0">Restrict employee sign-in to the society premises. Applies to employees only.</p>
                                                        </div>
                                                    </div>
                                                    <ToggleSwitch
                                                        id="geofence_enabled"
                                                        checked={formik.values.geofence_enabled}
                                                        onChange={(on) => formik.setFieldValue('geofence_enabled', on ? 1 : 0)}
                                                        label={formik.values.geofence_enabled ? 'Enabled' : 'Disabled'}
                                                    />
                                                </div>

                                                {!!formik.values.geofence_enabled && (
                                                    <div className="tw-mt-4">
                                                        {/* Not-configured warning */}
                                                        {(!formik.values.geofence_latitude || !formik.values.geofence_longitude) && (
                                                            <div className="tw-flex tw-items-center tw-gap-1.5 tw-px-3 tw-py-1.5 tw-mb-3 tw-rounded-md tw-bg-amber-50 tw-border tw-border-amber-200 tw-text-xs tw-text-amber-800" role="alert">
                                                                <Icon icon="mdi:alert-outline" className="tw-text-sm tw-flex-shrink-0" />
                                                                Geofence is enabled but no center is set — it will <strong>not</strong> block anyone until you set a location and radius.
                                                            </div>
                                                        )}

                                                        <div className="row gy-3 align-items-end">
                                                            <div className="col-md-4">
                                                                <label className={labelCls}>Center Latitude</label>
                                                                <TextField
                                                                    type="number"
                                                                    value={formik.values.geofence_latitude ?? ''}
                                                                    label="e.g. 19.1191"
                                                                    variant="outlined"
                                                                    size="small"
                                                                    className='tw-w-full'
                                                                    sx={textFieldStyles}
                                                                    onInput={(e) => formik.setFieldValue('geofence_latitude', e.target.value)}
                                                                />
                                                                <div className="text-danger text-sm italic h-4 text-wrap break-words mb-4">
                                                                    <ErrorMessage name="geofence_latitude" />
                                                                </div>
                                                            </div>
                                                            <div className="col-md-4">
                                                                <label className={labelCls}>Center Longitude</label>
                                                                <TextField
                                                                    type="number"
                                                                    value={formik.values.geofence_longitude ?? ''}
                                                                    label="e.g. 72.8465"
                                                                    variant="outlined"
                                                                    size="small"
                                                                    className='tw-w-full'
                                                                    sx={textFieldStyles}
                                                                    onInput={(e) => formik.setFieldValue('geofence_longitude', e.target.value)}
                                                                />
                                                                <div className="text-danger text-sm italic h-4 text-wrap break-words mb-4">
                                                                    <ErrorMessage name="geofence_longitude" />
                                                                </div>
                                                            </div>
                                                            <div className="col-md-4">
                                                                <button
                                                                    type="button"
                                                                    disabled={locating}
                                                                    onClick={async () => {
                                                                        setLocating(true);
                                                                        const c = await getCoords();
                                                                        setLocating(false);
                                                                        if (c.latitude != null && c.longitude != null) {
                                                                            formik.setFieldValue('geofence_latitude', c.latitude);
                                                                            formik.setFieldValue('geofence_longitude', c.longitude);
                                                                        }
                                                                    }}
                                                                    className="tw-w-full tw-h-[34px] tw-inline-flex tw-items-center tw-justify-center tw-gap-1 tw-px-3 tw-rounded-md tw-text-xs tw-font-medium tw-text-blue-600 tw-bg-white tw-border tw-border-blue-500 hover:tw-bg-blue-50 disabled:tw-opacity-50"
                                                                >
                                                                    {locating
                                                                        ? <span className='tw-animate-spin tw-rounded-full tw-h-3 tw-w-3 tw-border-2 tw-border-gray-300 tw-border-t-primary-600' />
                                                                        : <Icon icon="mdi:crosshairs-gps" />}
                                                                    Use my current location
                                                                </button>
                                                                <p className="tw-text-[11px] tw-text-gray-400 tw-mb-0 tw-mt-1">Tip: use the society gate/entrance.</p>
                                                            </div>

                                                            <div className="col-md-8">
                                                                <label className={`${labelCls} tw-flex tw-justify-between`}>
                                                                    <span>Radius (meters)</span>
                                                                    <span className="tw-text-blue-600">{formik.values.geofence_radius_meters || 0} m</span>
                                                                </label>
                                                                <input
                                                                    type="range"
                                                                    className="form-range"
                                                                    min={10}
                                                                    max={2000}
                                                                    step={10}
                                                                    value={Math.min(Number(formik.values.geofence_radius_meters) || 200, 2000)}
                                                                    onChange={(e) => formik.setFieldValue('geofence_radius_meters', Number(e.target.value))}
                                                                />
                                                                <div className="text-danger text-sm italic h-4 text-wrap break-words mb-4">
                                                                    <ErrorMessage name="geofence_radius_meters" />
                                                                </div>
                                                            </div>
                                                            <div className="col-md-4">
                                                                <label className={labelCls}>Exact radius</label>
                                                                <TextField
                                                                    type="number"
                                                                    value={formik.values.geofence_radius_meters ?? ''}
                                                                    label="10 - 100000"
                                                                    variant="outlined"
                                                                    size="small"
                                                                    className='tw-w-full'
                                                                    sx={textFieldStyles}
                                                                    onInput={(e) => formik.setFieldValue('geofence_radius_meters', e.target.value)}
                                                                />
                                                            </div>

                                                            <div className="col-12">
                                                                <ToggleSwitch
                                                                    id="geofence_enforce"
                                                                    checked={formik.values.geofence_enforce}
                                                                    onChange={(on) => formik.setFieldValue('geofence_enforce', on ? 1 : 0)}
                                                                    label="Enforce"
                                                                    description={'Block sign-in outside the radius (off = allow but flag as "outside premises")'}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        {/* =================== End Employee Geofence =================== */}

                                        {/* <div className="col-md-4">
                                            <label className={labelCls}>Email Address <span className="text-danger">*</span></label>
                                            <div>
                                                <TextField
                                                    id="outlined-basic"
                                                    label="Enter Value"
                                                    variant="outlined"
                                                    size="small"
                                                    className='tw-w-full'
                                                    sx={{
                                                        '& .MuiInputLabel-root': {
                                                            fontSize: '14px',
                                                        },
                                                        // Reduces the size of the placeholder specifically
                                                        // '& .MuiInputBase-input::placeholder': {
                                                        //     fontSize: '8px',
                                                        //     opacity: 1, // Ensures size change is visible
                                                        // },
                                                    }}
                                                />
                                            </div>
                                        </div>

                                        <div className="col-md-4">
                                            <label className={labelCls}>Phone Number <span className="text-danger">*</span></label>
                                            <div>
                                                <TextField
                                                    id="outlined-basic"
                                                    label="Enter Value"
                                                    variant="outlined"
                                                    size="small"
                                                    className='tw-w-full'
                                                    sx={{
                                                        '& .MuiInputLabel-root': {
                                                            fontSize: '14px',
                                                        },
                                                        // Reduces the size of the placeholder specifically
                                                        // '& .MuiInputBase-input::placeholder': {
                                                        //     fontSize: '8px',
                                                        //     opacity: 1, // Ensures size change is visible
                                                        // },
                                                    }}
                                                />
                                            </div>
                                        </div> */}

                                        {/* <div className="col-md-4">
                                            <label className={labelCls}>Website </label>
                                            <div>
                                                <TextField
                                                    id="outlined-basic"
                                                    label="Enter Value"
                                                    variant="outlined"
                                                    size="small"
                                                    className='tw-w-full'
                                                    sx={{
                                                        '& .MuiInputLabel-root': {
                                                            fontSize: '14px',
                                                        },
                                                        // Reduces the size of the placeholder specifically
                                                        // '& .MuiInputBase-input::placeholder': {
                                                        //     fontSize: '8px',
                                                        //     opacity: 1, // Ensures size change is visible
                                                        // },
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <label className={labelCls}>Local Area </label>
                                            <div>
                                                <TextField
                                                    id="outlined-basic"
                                                    label="Enter Value"
                                                    variant="outlined"
                                                    size="small"
                                                    className='tw-w-full'
                                                    sx={{
                                                        '& .MuiInputLabel-root': {
                                                            fontSize: '14px',
                                                        },
                                                        // Reduces the size of the placeholder specifically
                                                        // '& .MuiInputBase-input::placeholder': {
                                                        //     fontSize: '8px',
                                                        //     opacity: 1, // Ensures size change is visible
                                                        // },
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <label className={labelCls}>About </label>
                                            <div>
                                                <TextField
                                                    // id="outlined-basic"
                                                    label="Enter Value"
                                                    variant="outlined"
                                                    size="small"
                                                    multiline
                                                    rows={3} // Standard textarea behavior
                                                    className='tw-w-full'
                                                    sx={{
                                                        '& .MuiInputLabel-root': {
                                                            fontSize: '14px',
                                                        },
                                                        // Reduces the size of the placeholder specifically
                                                        // '& .MuiInputBase-input::placeholder': {
                                                        //     fontSize: '8px',
                                                        //     opacity: 1, // Ensures size change is visible
                                                        // },
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <label className={labelCls}>Other Details </label>
                                            <div>
                                                <TextField
                                                    // id="outlined-basic"
                                                    label="Enter Value"
                                                    variant="outlined"
                                                    size="small"
                                                    multiline
                                                    rows={3} // Standard textarea behavior
                                                    className='tw-w-full'
                                                    sx={{
                                                        '& .MuiInputLabel-root': {
                                                            fontSize: '14px',
                                                        },
                                                        // Reduces the size of the placeholder specifically
                                                        // '& .MuiInputBase-input::placeholder': {
                                                        //     fontSize: '8px',
                                                        //     opacity: 1, // Ensures size change is visible
                                                        // },
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <label className={labelCls}>Community Address </label>
                                            <div>
                                                <TextField
                                                    // id="outlined-basic"
                                                    label="Enter Value"
                                                    variant="outlined"
                                                    size="small"
                                                    multiline
                                                    rows={3} // Standard textarea behavior
                                                    className='tw-w-full'
                                                    sx={{
                                                        '& .MuiInputLabel-root': {
                                                            fontSize: '14px',
                                                        },
                                                        // Reduces the size of the placeholder specifically
                                                        // '& .MuiInputBase-input::placeholder': {
                                                        //     fontSize: '8px',
                                                        //     opacity: 1, // Ensures size change is visible
                                                        // },
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <label className={labelCls}>Postal Code </label>
                                            <div>
                                                <TextField
                                                    // id="outlined-basic"
                                                    label="Enter Value"
                                                    variant="outlined"
                                                    size="small"
                                                    className='tw-w-full'
                                                    sx={{
                                                        '& .MuiInputLabel-root': {
                                                            fontSize: '14px',
                                                        },
                                                        // Reduces the size of the placeholder specifically
                                                        // '& .MuiInputBase-input::placeholder': {
                                                        //     fontSize: '8px',
                                                        //     opacity: 1, // Ensures size change is visible
                                                        // },
                                                    }}
                                                />
                                            </div>
                                        </div> */}

                                        {/* <div className="col-md-4">
                                            <label className={labelCls}>Brand </label>
                                            <div>
                                                <FormControl sx={{ m: 0, width: '100%' }} size="small" className=''>
                                                    <Select
                                                        labelId="demo-select-small-label"
                                                        id="demo-select-small"
                                                        value={10}
                                                        // label="Age"
                                                        sx={{
                                                            '& .MuiInputBase-input': {
                                                                fontSize: '16px',
                                                            }
                                                        }}
                                                        onChange={() => { }}
                                                    >
                                                        <MenuItem value="">
                                                            <em>None</em>
                                                        </MenuItem>
                                                        <MenuItem value={10}>Brand 1</MenuItem>
                                                        <MenuItem value={20}>BRand 2</MenuItem>
                                                    </Select>
                                                </FormControl>
                                            </div>
                                        </div> */}

                                        {/* <div className="col-md-4">
                                            <label className={labelCls}>Project </label>
                                            <div>
                                                <FormControl sx={{ m: 0, width: '100%' }} size="small" className=''>
                                                    <Select
                                                        labelId="demo-select-small-label"
                                                        id="demo-select-small"
                                                        value={10}
                                                        // label="Age"
                                                        sx={{
                                                            '& .MuiInputBase-input': {
                                                                fontSize: '16px',
                                                            }
                                                        }}
                                                        onChange={() => { }}
                                                    >
                                                        <MenuItem value="">
                                                            <em>None</em>
                                                        </MenuItem>
                                                        <MenuItem value={10}>Project 1</MenuItem>
                                                        <MenuItem value={20}>Project 2</MenuItem>
                                                    </Select>
                                                </FormControl>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <label className={labelCls}>Country </label>
                                            <div>
                                                <FormControl sx={{ m: 0, width: '100%' }} size="small" className=''>
                                                    <Select
                                                        labelId="demo-select-small-label"
                                                        id="demo-select-small"
                                                        value={10}
                                                        // label="Age"
                                                        sx={{
                                                            '& .MuiInputBase-input': {
                                                                fontSize: '16px',
                                                            }
                                                        }}
                                                        onChange={() => { }}
                                                    >
                                                        <MenuItem value="">
                                                            <em>None</em>
                                                        </MenuItem>
                                                        <MenuItem value={10}>Country 1</MenuItem>
                                                        <MenuItem value={20}>Country 2</MenuItem>
                                                    </Select>
                                                </FormControl>
                                            </div>
                                        </div> */}
                                        {/* <div className="col-md-4">
                                            <label className={labelCls}>Country </label>
                                            <div>
                                                <FormControl sx={{ m: 0, width: '100%' }} size="small" className=''>
                                         <Select
                                            labelId="demo-select-small-label"
                                            id="demo-select-small"
                                            value={10}
                                            // label="Age"
                                            sx={{
                                                '& .MuiInputBase-input': {
                                                    fontSize: '16px',
                                                }
                                            }}
                                            onChange={() => { }}
                                        >
                                            <MenuItem value="">
                                                <em>None</em>
                                            </MenuItem>
                                            <MenuItem value={10}>Country 1</MenuItem>
                                            <MenuItem value={20}>Country 2</MenuItem>
                                        </Select>
                                    </FormControl>
                                </div>
                            </div> */}
                                        {/* <div className="col-md-4">
                                            <label className={labelCls}>State </label>
                                            <div>
                                                <FormControl sx={{ m: 0, width: '100%' }} size="small" className=''>
                                         <Select
                                            labelId="demo-select-small-label"
                                            id="demo-select-small"
                                            value={10}
                                            // label="Age"
                                            sx={{
                                                '& .MuiInputBase-input': {
                                                    fontSize: '16px',
                                                }
                                            }}
                                            onChange={() => { }}
                                        >
                                            <MenuItem value="">
                                                <em>None</em>
                                            </MenuItem>
                                            <MenuItem value={10}>State 1</MenuItem>
                                            <MenuItem value={20}>State 2</MenuItem>
                                        </Select>
                                    </FormControl>
                                </div>
                            </div> */}
                                        {/* <div className="col-md-4">
                                            <label className={labelCls}>City  </label>
                                            <div>
                                                <FormControl sx={{ m: 0, width: '100%' }} size="small" className=''>
                                                    <Select
                                                        labelId="demo-select-small-label"
                                                        id="demo-select-small"
                                                        value={10}
                                                        // label="Age"
                                                        sx={{
                                                            '& .MuiInputBase-input': {
                                                                fontSize: '16px',
                                                            }
                                                        }}
                                                        onChange={() => { }}
                                                        defaultValue={0}
                                                    >
                                                        <MenuItem value={0}>
                                                            <em>None</em>
                                                        </MenuItem>
                                                        <MenuItem value={10}>State 1</MenuItem>
                                                        <MenuItem value={20}>State 2</MenuItem>
                                                    </Select>
                                                </FormControl>
                                            </div>
                                        </div> */}

                                        {/* <div className="col-md-4">
                                            <label className={labelCls}>Community Support Email </label>
                                            <div>
                                                <TextField
                                                    // id="outlined-basic"
                                                    label="Enter Value"
                                                    variant="outlined"
                                                    size="small"
                                                    className='tw-w-full'
                                                    sx={{
                                                        '& .MuiInputLabel-root': {
                                                            fontSize: '14px',
                                                        },
                                                        // Reduces the size of the placeholder specifically
                                                        // '& .MuiInputBase-input::placeholder': {
                                                        //     fontSize: '8px',
                                                        //     opacity: 1, // Ensures size change is visible
                                                        // },
                                                    }}
                                                />
                                            </div>
                                        </div> */}
                                    </div>
                                </div>}
                            </div >

                            {/* Assigned Users (only on edit / details view) */}
                            {id && Array.isArray(communityDetails?.users) && (
                                <div className="tw-bg-white tw-rounded-xl tw-border tw-border-gray-100 tw-shadow-sm tw-overflow-hidden tw-mt-4">
                                    <div className="tw-px-4 tw-py-3 tw-border-b tw-border-gray-100 tw-flex tw-items-center tw-justify-between tw-gap-2">
                                        <div className="tw-flex tw-items-center tw-gap-2">
                                            <Icon icon="solar:users-group-rounded-bold" className="tw-text-rose-500 tw-text-base" />
                                            <h6 className="tw-text-sm tw-font-bold tw-text-gray-800 tw-mb-0">Assigned Users</h6>
                                            <span className="tw-inline-flex tw-items-center tw-px-2 tw-py-0.5 tw-rounded-full tw-bg-rose-50 tw-text-rose-600 tw-text-[10px] tw-font-medium">
                                                {communityDetails.users.length}
                                            </span>
                                        </div>
                                    </div>

                                    <div className="tw-overflow-x-auto">
                                        {communityDetails.users.length === 0 ? (
                                            <div className="tw-flex tw-flex-col tw-items-center tw-gap-2 tw-py-10">
                                                <Icon icon="mdi:account-off-outline" className="tw-text-3xl tw-text-gray-300" />
                                                <p className="tw-text-xs tw-text-gray-400">No users assigned to this community</p>
                                            </div>
                                        ) : (
                                            <table className="tw-w-full tw-text-xs">
                                                <thead>
                                                    <tr className="tw-bg-gradient-to-r tw-from-slate-50 tw-to-gray-50">
                                                        <th style={{ minWidth: 50 }} className="tw-text-left tw-px-4 tw-py-3 tw-font-bold tw-text-gray-700 tw-uppercase tw-tracking-wider tw-text-[10px]">#</th>
                                                        <th style={{ minWidth: 220 }} className="tw-text-left tw-px-4 tw-py-3 tw-font-bold tw-text-gray-700 tw-uppercase tw-tracking-wider tw-text-[10px]">User</th>
                                                        <th style={{ minWidth: 160 }} className="tw-text-left tw-px-4 tw-py-3 tw-font-bold tw-text-gray-700 tw-uppercase tw-tracking-wider tw-text-[10px]">Role</th>
                                                        <th style={{ minWidth: 140 }} className="tw-text-left tw-px-4 tw-py-3 tw-font-bold tw-text-gray-700 tw-uppercase tw-tracking-wider tw-text-[10px]">Phone</th>
                                                        <th style={{ minWidth: 100 }} className="tw-text-left tw-px-4 tw-py-3 tw-font-bold tw-text-gray-700 tw-uppercase tw-tracking-wider tw-text-[10px]">Primary</th>
                                                        <th style={{ minWidth: 110 }} className="tw-text-left tw-px-4 tw-py-3 tw-font-bold tw-text-gray-700 tw-uppercase tw-tracking-wider tw-text-[10px]">Status</th>
                                                        <th style={{ minWidth: 140 }} className="tw-text-left tw-px-4 tw-py-3 tw-font-bold tw-text-gray-700 tw-uppercase tw-tracking-wider tw-text-[10px]">Assigned</th>
                                                    </tr>
                                                </thead>
                                                <tbody className="tw-divide-y tw-divide-gray-50">
                                                    {communityDetails.users.map((row, index) => {
                                                        const u = row?.user || {};
                                                        const fullName = [u.first_name, u.last_name].filter(Boolean).join(' ').trim() || '—';
                                                        const initial = (u.first_name || u.email || '?').charAt(0).toUpperCase();
                                                        const isActive = u.is_active === 1 || u.is_active === true;
                                                        const assigned = row?.assigned_at
                                                            ? new Date(row.assigned_at).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })
                                                            : '—';
                                                        return (
                                                            <tr key={row?.user_society_id || `${u.user_id}-${index}`} className="hover:tw-bg-slate-50/50 tw-transition-colors">
                                                                <td className="tw-px-4 tw-py-2.5 tw-text-gray-400">{index + 1}</td>
                                                                <td className="tw-px-4 tw-py-2.5">
                                                                    <div className="tw-flex tw-items-center tw-gap-2">
                                                                        <div className="tw-w-7 tw-h-7 tw-rounded-full tw-bg-rose-50 tw-flex tw-items-center tw-justify-center tw-flex-shrink-0 tw-text-rose-600 tw-font-semibold tw-text-[10px]">
                                                                            {initial}
                                                                        </div>
                                                                        <div className="tw-min-w-0">
                                                                            <div className="tw-font-medium tw-text-gray-800 tw-truncate">{fullName}</div>
                                                                            <div className="tw-text-[10px] tw-text-gray-400 tw-truncate">{u.email || '—'}</div>
                                                                        </div>
                                                                        {u.is_super_admin ? (
                                                                            <span className="tw-inline-block tw-px-1.5 tw-py-0.5 tw-rounded tw-bg-amber-50 tw-text-amber-600 tw-text-[9px] tw-font-medium tw-flex-shrink-0">
                                                                                SUPER
                                                                            </span>
                                                                        ) : null}
                                                                    </div>
                                                                </td>
                                                                <td className="tw-px-4 tw-py-2.5">
                                                                    <span className="tw-inline-block tw-px-2 tw-py-0.5 tw-rounded-full tw-bg-indigo-50 tw-text-indigo-600 tw-text-[10px] tw-font-medium">
                                                                        {row?.role?.role_name || '—'}
                                                                    </span>
                                                                    {row?.role?.role_code ? (
                                                                        <div className="tw-text-[9px] tw-text-gray-400 tw-font-mono tw-mt-0.5">{row.role.role_code}</div>
                                                                    ) : null}
                                                                </td>
                                                                <td className="tw-px-4 tw-py-2.5 tw-text-gray-600">{u.phone || '—'}</td>
                                                                <td className="tw-px-4 tw-py-2.5">
                                                                    {row?.is_primary ? (
                                                                        <span className="tw-inline-flex tw-items-center tw-gap-1 tw-text-rose-600 tw-text-[10px] tw-font-medium">
                                                                            <Icon icon="solar:star-bold" className="tw-text-xs" />
                                                                            Primary
                                                                        </span>
                                                                    ) : (
                                                                        <span className="tw-text-[10px] tw-text-gray-400">—</span>
                                                                    )}
                                                                </td>
                                                                <td className="tw-px-4 tw-py-2.5">
                                                                    <span className={`tw-inline-flex tw-items-center tw-gap-1 tw-px-2 tw-py-0.5 tw-rounded-full tw-text-[10px] tw-font-medium tw-border ${
                                                                        isActive
                                                                            ? 'tw-bg-emerald-50 tw-text-emerald-600 tw-border-emerald-100'
                                                                            : 'tw-bg-gray-50 tw-text-gray-500 tw-border-gray-100'
                                                                    }`}>
                                                                        <span className={`tw-w-1.5 tw-h-1.5 tw-rounded-full ${isActive ? 'tw-bg-emerald-500' : 'tw-bg-gray-400'}`}></span>
                                                                        {isActive ? 'Active' : 'Inactive'}
                                                                    </span>
                                                                </td>
                                                                <td className="tw-px-4 tw-py-2.5 tw-text-gray-500">{assigned}</td>
                                                            </tr>
                                                        );
                                                    })}
                                                </tbody>
                                            </table>
                                        )}
                                    </div>
                                </div>
                            )}
                        </Form >
                    )
                }}
            </Formik >
        </div >
    );
};

export default InputCustomStyles;